<template>
  <div class="md:flex items-stretch">
    <div class="overflow-scroll flex-1">
      <div class="pb-8">
        <div class="px-8 py-4 border-b border-solid border-gray-200 bg-gray-100 flex justify-between">
          <div>
            <ais-current-refinements :included-attributes="[
              'categories.level1'
            ]" />
          </div>

          <div>
            <ais-stats />
          </div>

        </div>

        <ais-infinite-hits>

          <ul slot-scope="{ items, refineNext, isLastPage}">
            <li v-for="item in items" :key="item.objectID">

              <div class="product-card flex flex-row justify-between border-b border-solid border-gray-200 py-6 px-6">

                <router-link :to="{ name: 'product', params: { id: item.part_no, product: item } }"
                  class="flex flex-row flex-shrink">
                  <div class="product-card__image mr-4 w-16 flex-shrink-0">
                    <img :src="item.thumbnail" class="block w-full" v-if="item.thumbnail">
                    <img src="/images/placeholder.jpg" v-else>
                  </div>

                  <div class="product-card__main flex flex-col justify-center">
                    <h2 class="text-lg font-semibold uppercase mb-2 leading-tight">
                      <ais-highlight attribute="description" :hit="item" />
                    </h2>

                    <table class="w-full">
                      <tr class="leading-tight">
                        <td class="w-32 pr-3">
                          IMPA Code:
                        </td>
                        <td class="font-mono font-bold">
                          <ais-highlight attribute="part_no" :hit="item" />
                        </td>
                      </tr>
                      <tr class="leading-tight">
                        <td class="o w-32 pr-3">
                          UOM:
                        </td>
                        <td class="font-mono font-bold">
                          {{ item.uom }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </router-link>

                <div class="hidden xl:flex items-center  justify-end xl:w-3/12 ml-4 flex-shrink-0"
                  v-if="!$store.state.user.userGroups.includes('trial')">
                  <a href="#" class="inline-block button cursor-pointer" @click="addProductToCart(item)">
                    <font-awesome-icon icon="plus" class="mr-2" /> Add to basket
                  </a>
                </div>
              </div>
            </li>
            <li class="text-center m-4" v-if="!isLastPage">
              <button @click="refineNext" class="button">
                Show more results
              </button>
            </li>
            <!-- <li v-if="items.length == 0">
            No results found <ais-clear-refinements />
          </li> -->
          </ul>


        </ais-infinite-hits>

        <ais-state-results class="p-8">
          <template slot-scope="{ hits, query }">
            <div></div>
            <div v-if="hits.length == 0">
              No results have been found for <strong>{{ query }}</strong>.
            </div>
          </template>
        </ais-state-results>

      </div>
    </div>
    <iframe src="/advert/sidebar" frameborder="0" class="hidden lg:block p-6 w-64 bg-gray-200"></iframe>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    addProductToCart(product) {
      this.$store.dispatch('cart/addProductToCart', product)
      this.$ga.event({
        eventCategory: 'Basket',
        eventAction: 'add',
        eventValue: product.part_no
      })
    },
  }
}
</script>

<style>
.ais-CurrentRefinements {
  @apply text-sm
}

.ais-CurrentRefinements-label {
  display: none
}

.ais-CurrentRefinements-label:before {
  content: 'hi'
}

.ais-CurrentRefinements-category {
  @apply px-2 py-1 bg-gray-800 text-gray-200 rounded-lg;
}

.ais-Highlight-highlighted {
  @apply bg-yellow-200
}

.ais-CurrentRefinements-delete {
  @apply text-white
}
</style>